import { useEffect } from 'react';

const DAILY_MESSAGES = [
  "Ta en stund för dig själv idag. Du förtjänar det.",
  "Hur mår du just nu? Din dagbok väntar på dig.",
  "Påminnelse: Det är okej att känna det du känner.",
  "En djup andning kan göra stor skillnad. Prova en övning idag.",
  "Du är starkare än du tror. Varje steg räknas.",
  "Idag är en ny dag med nya möjligheter att vara snäll mot dig själv.",
  "Ta dig tid att reflektera. Dina tankar är värdefulla.",
  "Kom ihåg: Du behöver inte vara perfekt, bara närvarande."
];

export function useDailyReminder() {
  useEffect(() => {
    const checkAndShowNotification = () => {
      // Check if notifications are enabled
      const notificationsEnabled = localStorage.getItem('notifications-enabled') === 'true';
      
      if (!notificationsEnabled || !('Notification' in window) || Notification.permission !== 'granted') {
        return;
      }

      // Check if we've already shown a notification today
      const lastNotification = localStorage.getItem('last-notification-date');
      const today = new Date().toDateString();
      
      if (lastNotification === today) {
        return;
      }

      // Only show between 9 AM and 8 PM
      const hour = new Date().getHours();
      if (hour < 9 || hour > 20) {
        return;
      }

      // Show notification
      const message = DAILY_MESSAGES[Math.floor(Math.random() * DAILY_MESSAGES.length)];
      
      new Notification('Livon', {
        body: message,
        icon: '/icons/icon.svg',
        tag: 'daily-reminder'
      });
      
      localStorage.setItem('last-notification-date', today);
    };

    // Check on mount
    const timer = setTimeout(checkAndShowNotification, 2000);

    return () => clearTimeout(timer);
  }, []);
}

export default useDailyReminder;
